import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { displayAccountLabel } from "@common/helpers/accounting";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { useAccounts } from "@hooks/useAccounts";
import { useShowAccountNumbers } from "@hooks/useShowAccountNumbers";
import { HistoryCreatedTransactionDetailsRow } from "../views/historyCreatedTransactionDetailsViewConfig";

export const HistoryCreatedTransactionLedgerCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        HistoryCreatedTransactionDetailsRow,
        unknown
    >) => {
        const { accountId: ledgerAccountId, accountLabel: ledgerAccountLabel } =
            row.original.ledger ?? {};
        const entityId = row.original.entityId ?? undefined;
        const showAccountNumbers = useShowAccountNumbers();

        const { accountsById } = useAccounts({
            entityId,
            includeDisabled: true,
        });

        const account = ledgerAccountId
            ? accountsById[ledgerAccountId]
            : undefined;

        const label = account
            ? displayAccountLabel(account, showAccountNumbers)
            : ledgerAccountLabel;

        if (!label) {
            return (
                <ViewTableCell>
                    <EmptyValue />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <BreakableText text={label} showTooltip />
            </ViewTableCell>
        );
    },
);

HistoryCreatedTransactionLedgerCell.displayName =
    "HistoryCreatedTransactionLedgerCell";
